import React, { useState, useEffect }  from 'react';
import { Link, useParams, useHistory} from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import dayjs from 'dayjs';
import 'dayjs/locale/ar';
import { Divider } from "@mui/material";
import {
    MoreVertOutlined,
    AccessTimeOutlined,
    Person2Outlined,
    ArticleOutlined,
    CreditCardOutlined,
    FlagOutlined,
    Check,
    Clear,
    EditLocationAltOutlined,
    CategoryOutlined,
    RepeatOutlined,
    EventAvailableOutlined,
    HistoryOutlined,
    NumbersOutlined,
    CalendarMonthOutlined,
    }from '@mui/icons-material';

import { getBookingRequest,
         getBookingResponse,
         editBookingServiceRequest,
         getBookingCancelationReasonsRequest,
         getBookingServiceCancelationReasonsRequest,
         updateBookingRequest,
         getRequestStatus } from '../../../store/Bookings/actions.js'
import messages from '../../../assets/locale/messages';
import { ROUTE_PATHS } from '../../../utils/RoutesPaths';
import { setPageMainTitle, timeConverter } from '../../../utils/Helpers';
import BookingCancelationReasonForm from './BookingCancelationReasonForm'
import BookingServiceCancelationReasonForm from './BookingServiceCancelationReasons'
import BookingFirstSessionCancelForm from './BookingFirstSessionCancelForm'
import BookingSubsequentSessionCancelForm from './BookingSubsequentSessionCancelForm'
import Breadcrumbs  from'../../../components/BreadCrumbs';
import Button from '../../../components/Button';
import Menu from '../../../components/Menu';
import Modal from '../../../components/Modal';
import SelectLocation from '../../Branches/SelectLocation';
import { renderTextEllipsis } from '../../../utils/Helpers';
import './ViewBooking.scss';

const ViewBooking = () => {

    const dispatch = useDispatch();
    const history = useHistory();
    const { id } = useParams();
    const lang = useSelector((state) => state.locale.lang);
    const bookingData = useSelector((state) => state.bookings.bookingDetails);
    const requestStatus = useSelector((state) => state.bookings.requestStatus);
    const { bookings, shared, branches } = messages[lang];
    const [hasDoneService, setHasDoneService] = useState(false);
    const [showRefuseToCancelPopup, setShowRefuseToCancelPopup] = useState(false);
    const [showCancelUpcomingPopup, setShowUpcomingAppointmentPopup] = useState(false);
    const [showBookingCancelationReasonPopup, setShowBookingCancelationReasonPopup] = useState(false);
    const [showServiceCancelationReasonPopup, setShowServiceCancelationReasonPopup] =useState(false);
    const [cancelService, setCancelService] = useState({});
    const [showFirstSessionCancelForm, setShowFirstSessionCancelForm] = useState(false);
    const [firstSessionButtonType, setFirstSessionButtonType] = useState('above');
    const [showSubsequentSessionCancelForm, setShowSubsequentSessionCancelForm] = useState(false);
    const [subsequentSessionButtonType, setSubsequentSessionButtonType] = useState('above');
    const [subsequentCancelService, setSubsequentCancelService] = useState({});
    const [doneServicesCounter,setDoneServicesCounter] = useState(0)
    const [cancelledServicesCounter,setCancelledServicesCounter] = useState(0)
    const [openMap, setOpenMap] = useState(false);

    useEffect(() => {
        return () => {
          dispatch(
            getBookingResponse({bookingDetails:{}})
          )
        };
      }, []);

    useEffect(()=>{
        setPageMainTitle('bookingsManagement');
        dispatch(getBookingRequest(id));
    },[lang, requestStatus])

    useEffect(() => {
       const doneServices = bookingData?.appointment_branch_services?.filter((service) => service.status==='completed');
       setDoneServicesCounter(doneServices?.length);
       const cancelledServices = bookingData?.appointment_branch_services?.filter((service) => service.status==='canceled');
       setCancelledServicesCounter(cancelledServices?.length)
       if(doneServices?.length > 0) {
        setHasDoneService(true);
       }else{
        setHasDoneService(false);
       }
    }, [bookingData])

    useEffect(() => {
        if(bookingData?.status==='ongoing'){
            dispatch(getBookingCancelationReasonsRequest())
            dispatch(getBookingServiceCancelationReasonsRequest())
        }
    },[lang, bookingData])

    const showMenuList = (service) => {
        if(service.status === 'completed'){
            return [
                {
                    id:1,
                    label:<div>{shared.cancel}</div>,
                }
            ]
        }else if(service.status === 'canceled'){
            return [
                {
                    id:1,
                    label: <div>{bookings.details.markAsDone}</div>,
                }
            ]
        }else {
            if(service.employee_did_not_show_up){
                return [
                    {
                        id:1,
                        label:<div>{shared.cancel}</div>,
                    },
                    {
                        id:2,
                        label:<div>{bookings.details.resolve}</div>,
                    }
                ]
            }else{
                return [
                    {
                        id:1,
                        label:<div>{shared.cancel}</div>,
                    },
                    {
                        id:2,
                        label:<div>{bookings.details.markAsDone}</div>,
                    }
                ]
            }  
        }
    }

    const getBookingStatusLabel = (booking) => {
        if (booking?.status === 'canceled' && booking?.refund_state === 'refunded') {
            return bookings.status.canceledRefunded;
        }
        if (booking?.status === 'completed' && booking?.refund_state === 'partially_refunded') {
            return bookings.status.completedPartiallyRefunded;
        }
        if (booking?.status === 'canceled' && booking?.refund_state === 'partially_refunded') {
            return bookings.status.canceledPartiallyRefunded;
        }
        return bookings.status[booking?.status];
    };

    const handleMarkAsDone = (service) => {
        let exactFees = service.exact_fees;

        if (exactFees === null || exactFees === undefined || Number.isNaN(Number(exactFees))) {
            exactFees = service.fees_from;
        }

        const numericExactFees = Number(exactFees);

        if (Number.isNaN(numericExactFees)) {
            return;
        }

        dispatch(editBookingServiceRequest({
            id: service.id,
            data: {
                exact_fees: numericExactFees,
                status: 'completed',
            }
        }))
        dispatch(getRequestStatus(false));
    };

    const isMultiSessionOngoing = bookingData?.service_type === 'multi_session' && bookingData?.status === 'ongoing';
    const isSubsequentSessionMultiSession = isMultiSessionOngoing && bookingData?.session_number > 1;
    const isFirstSessionMultiSession = isMultiSessionOngoing && !isSubsequentSessionMultiSession;
    const isUpcomingSubsequentMultiSession = bookingData?.service_type === 'multi_session' && bookingData?.status === 'upcoming' && bookingData?.session_number > 1;
    const isUpcomingFirstSessionMultiSession = bookingData?.service_type === 'multi_session' && bookingData?.status === 'upcoming' && !(bookingData?.session_number > 1);

    const handleCancelService = (service) => {
        if (isFirstSessionMultiSession) {
            setFirstSessionButtonType('below');
            setCancelService(service);
            setShowFirstSessionCancelForm(true);
        } else if (isSubsequentSessionMultiSession) {
            setSubsequentSessionButtonType('below');
            setSubsequentCancelService(service);
            setShowSubsequentSessionCancelForm(true);
        } else {
            setShowServiceCancelationReasonPopup(true);
            setCancelService(service);
        }
    };

    const handleResolve = (service) => {
        dispatch(editBookingServiceRequest({
            id: service.id,
            data: {
                employee_did_not_show_up: false
            }
        }))
        dispatch(getRequestStatus(false));
    }

    const handleOnClickItem = (listItem, service) => {
        if(service.status==='canceled'){
            handleMarkAsDone(service);
        }else if (service.status==='completed'){
            if(listItem.id === 1){
                handleCancelService(service);
            };
        }else{
            if(listItem.id === 1){
                handleCancelService(service);
            }else if(listItem.id === 2){
                if(service.employee_did_not_show_up){
                    handleResolve(service);
                }else{
                    handleMarkAsDone(service);
                }
                
            };
        }; 
    };

    const handleCancelOngoingAppointment = () => {
        if (isFirstSessionMultiSession) {
            setFirstSessionButtonType('above');
            setShowFirstSessionCancelForm(true);
        } else if (isSubsequentSessionMultiSession) {
            setSubsequentSessionButtonType('above');
            setShowSubsequentSessionCancelForm(true);
        } else if(hasDoneService){
            setShowRefuseToCancelPopup(true);
        }else{
            setShowBookingCancelationReasonPopup(true)
        };
    };

    const handleCloseRefuseToCancel = () => {
        setShowRefuseToCancelPopup(false);
    };

    const handleCancelUpcomingAppointment = () => {
        setShowUpcomingAppointmentPopup(true);
    };

    const handleCloseCancelUpcoming = () => {
        setShowUpcomingAppointmentPopup(false);
    };

    const handleSubmitCancelUpcoming = () => {
        setShowUpcomingAppointmentPopup(false);
        const params = isUpcomingSubsequentMultiSession
            ? { status: "canceled", apply_refund: false, allow_reschedule: true }
            : { status: "canceled", apply_refund: true };
        dispatch(updateBookingRequest({
            data: { id: bookingData?.id, params },
            requestType: "cancel"
        }));
        dispatch(getRequestStatus(false));
    };

    const viewBranchPointerOnMap = () => {
        if (bookingData?.customer_address_snapshot?.lat && bookingData?.customer_address_snapshot?.lng) {
          return { coords: { lng: +bookingData.customer_address_snapshot.lng, lat: +bookingData.customer_address_snapshot.lat } };
        }
    };
     
    const isMultiSession = bookingData?.service_type === 'multi_session';

    const handleViewPackageHistory = () => {
        history.push(ROUTE_PATHS.bookingHistory.replace(':id', id));
    };

    return(
        <div className="booking-details-container">
            <div className="d-flex justify-content-between flex-wrap" >
                <div className="">
                    <Breadcrumbs
                        list={[
                            {
                                path: ROUTE_PATHS.bookings,
                                label: bookings.list.bookingList
                            },
                            {
                                path: "#",
                                label: bookings.details.booking + '(' +
                                bookingData?.appointment_number + ')',
                            },
                        ]}
                        className="mb-4 fsize-28 fweight-600"
                    />
                </div>
                <div className="d-flex gap-2 flex-wrap">
                    {isMultiSession && (
                        <div>
                            <Button
                                label={<div className="d-flex gap-1 px-4">
                                        <div><HistoryOutlined fontSize="medium"/></div>
                                        <div>{bookings.history.viewPackageHistory}</div>
                                    </div>}
                                labelClass="fsize-16 text-white pe-2 adjust-CTA"
                                className="mb-4"
                                onClick={handleViewPackageHistory}
                            />
                        </div>
                    )}
                {bookingData?.status === "ongoing" && (
                    <div>
                        <Button
                            label={<div className="d-flex gap-1 px-4">
                                    <div><Clear fontSize="medium"/></div>
                                    <div>{shared.cancel}</div>
                                </div>}
                            outlined
                            labelClass="text-primary fsize-16"
                            className="mb-4"
                            color="info"
                            onClick={() => {handleCancelOngoingAppointment()}}
                        />
                    </div>
                )}
                {bookingData?.status === "upcoming" && (
                    <div>
                        <Button
                            label={<span className="d-flex gap-1 px-4">
                                    <div><Clear fontSize="medium"/></div>
                                    <div>{shared.cancel}</div>
                                </span>}
                            outlined
                            labelClass="text-primary fsize-16"
                            className="mb-4"
                            color="info"
                            onClick={() => {handleCancelUpcomingAppointment()}}
                        />
                    </div>
                )}
                </div>
            </div>
            {bookingData?.employee_did_not_show_up && (
                <div className=" report-container row p-2 mb-4 fsize-24 fweight-500 rounded-4">
                    <div className="col-md-12 d-flex gap-1">
                        <div ><FlagOutlined fontSize="fweight-500"/></div>
                        <div className="mt-1">{bookings.details.customerReported}</div>
                    </div>
                </div>
            )}
             {bookingData?.customer_did_not_show_up && (
                <div className=" report-container row p-2 mb-4 fsize-24 fweight-500 rounded-4">
                <div className="col-md-12 d-flex gap-1">
                    <div ><FlagOutlined fontSize="fweight-500"/></div>
                    <div className="mt-1">{bookings.details.employeeReporeted}</div>
                </div>
            </div>
            )}
            <div className="bg-white row p-4 mb-3 mx-1 data-container">
                <div className=" col-12 col-md-4">
                    <div className="text-dark text-primary fsize-16 mb-2">
                        {bookings.details.appointmentId}
                    </div>
                    <div className="text-gray fsize-18">
                        {bookingData?.appointment_number}
                    </div>
                </div>  
                <div className=" col-12 col-md-4">
                    <div className="text-dark text-primary fsize-16 mb-2">
                        {bookings.details.date}
                    </div>
                    <div className="text-gray fsize-18">
                        {lang === 'en' ? 
                         dayjs(bookingData?.date).format("dddd, D MMMM  YYYY") :
                         dayjs(bookingData?.date).locale('ar').format("dddd, D MMMM  YYYY")
                        }
                    </div>
                </div> 
                <div className=" col-12 col-md-4 status-container mb-3">
                    <div className="text-dark text-primary fsize-16 mb-2">
                        {bookings.details.status}
                    </div>
                    <div className={`fsize-18 w-60 status-card text-center ${bookingData?.status}-container`}>
                       {getBookingStatusLabel(bookingData)}
                    </div>
                </div> 
                <div className=" col-12 col-md-4">
                    <div className="text-dark text-primary fsize-16 mb-2">
                        {bookings.details.paymentMethod}
                    </div>
                    <div className="text-gray fsize-18">
                        {bookings.details[bookingData?.payment_method]}
                    </div>
                </div>
                <div className=" col-12 col-md-4">
                <div className='d-flex align-items-center mb-2 gap-1'>
                        <div className="text-dark text-primary fsize-16">
                            {bookings.details.location}
                        </div>
                        {bookingData?.location === 'home' && <div
                            className="fsize-16 text-secondary d-flex gap-1 align-items-center pointer text-underline"
                            onClick={() => {
                                setOpenMap(true);
                            }}>
                            <EditLocationAltOutlined />
                            <div>{branches.viewBranch.labels.viewOnMap}</div>
                        </div>}
                    </div>
                    <div className="text-gray fsize-18">
                        {bookings.details[bookingData?.location]}
                        {bookingData?.location === 'home' && (
                            <span className='mx-1'>
                                ( {`${bookingData?.customer_address_snapshot?.building_number} ${bookingData?.customer_address_snapshot?.street_name}`}.
                                <span className='mx-1'>{bookingData?.customer_address_snapshot?.region}</span>
                                {bookingData?.customer_address_snapshot?.city},
                                <span className='mx-1'>{bookingData?.customer_address_snapshot?.country}.</span>)
                            </span>
                        )}
                    </div>
                </div>
            </div>
            {bookingData?.status === 'canceled' && (
                <div className="bg-white row p-4 mb-3 mx-1 data-container">
                    {bookingData?.appointment_cancellation_reason && (
                        <div className="my-1 my-md-2 col-12 col-md-4">
                            <div className="text-dark text-primary fsize-16 mb-2">
                                {bookings.details.cancellationReason}
                            </div>
                            <div className="text-gray fsize-18">
                                {bookingData?.appointment_cancellation_reason?.reason}
                            </div>
                        </div>
                    )}
                    <div className="my-1 my-md-2 col-12 col-md-4">
                        <div className="text-dark text-primary fsize-16 mb-2">
                            {bookings.details.cancelledBy}
                        </div>
                        <div className="text-gray fsize-18 mb-3">
                            {bookings.details[bookingData?.canceller_type]}
                        </div>
                        {bookingData?.service_type === 'multi_session' && bookingData?.is_reschedulable && (
                            <>
                                <div className="text-dark text-primary fsize-16 mb-2">
                                    {bookings.details.rescheduleStatus}
                                </div>
                                <div className="text-gray fsize-18">
                                    {bookingData?.is_reschedulable
                                        ? bookings.details.cancelledWithReschedule
                                        : bookings.details.cancelledWithoutReschedule}
                                </div>
                            </>
                        )}
                    </div>
                </div>
            )}
            {bookingData?.refund_state && (
                <div className="bg-white row p-4 mb-3 mx-1 data-container">
                    <div className="my-1 my-md-2 col-12 col-md-4">
                        <div className="text-dark text-primary fsize-16 mb-2">
                            {bookings.details.refundStatus}
                        </div>
                        <div className="text-gray fsize-18">
                            {bookings.details[bookingData?.refund_state]}
                        </div>
                    </div>
                </div>
            )}
            <div className="bg-white row p-4 mb-3 mx-1 data-container">
                <div className="my-1 my-md-2 col-12 col-md-12">
                    <div className="text-dark text-primary fsize-16 mb-2">
                        {bookings.details.branchName}
                    </div>
                    <div className="text-gray fsize-18">
                        {bookingData?.branch?.is_deleted 
                            ? (
                                <> 
                                    {lang === 'en'  
                                      ? bookingData?.branch?.name_en 
                                      : bookingData?.branch?.name_ar
                                    }
                                    <span> ({bookings.details.deletedBranch})</span>
                                </>
                            ):(
                                <Link
                                    to={ROUTE_PATHS.viewBranch.replace(':id', bookingData?.branch?.id)}
                                >
                                    { lang === 'en' ? 
                                        bookingData?.branch?.name_en :
                                        bookingData?.branch?.name_ar
                                    }
                                </Link>
                            )
                        }
                    </div>
                </div>
            </div>
            <div className="bg-white row p-4 mb-3 mx-1 data-container">
                <div className="my-1 my-md-2 col-12 col-md-12 mb-3">
                    <div className="text-dark text-primary fsize-16 mb-2">
                        {bookings.details.customerName}
                    </div>
                    <div className="text-gray fsize-18">
                        {bookingData?.customer?.name}
                    </div>
                </div>
                {!bookingData?.customer?.is_deleted && (
                    <div className="my-1 my-md-2 col-12 col-md-12 mb-3">
                        <div className="text-dark text-primary fsize-16 mb-2">
                            {bookings.details.customerPhoneNumber}
                        </div>
                        <  div className="text-gray fsize-18">
                            {bookingData?.customer?.phone_number}
                        </div>
                    </div>
                )}
                <div className="my-1 my-md-2 col-12 col-md-12 mb-3">
                    <div className="text-dark text-primary fsize-16 mb-2">
                        {bookings.details.customerNote}
                    </div>
                    <div className="text-gray fsize-18">
                        {bookingData?.note || bookings.details.noNotes}
                    </div>
                </div>
            </div>
            <div className="bg-white row p-4 mb-3 mx-1 data-container">
                <div className="my-1 my-md-2 col-12 col-md-12 d-flex justify-content-between">
                    <div className="text-dark text-primary fsize-16 mb-2">
                        {bookings.details.services}
                    </div>
                    {bookingData?.status === 'ongoing' && (
                        <div className="text-gray fsize-14">
                            {bookingData?.appointment_branch_services?.length}
                            <span className="mx-1">{bookings.details.services}</span>
                            (<span className="mx-1">{doneServicesCounter}</span>{bookings.status.completed} 
                            <span className="mx-1">&amp;</span> 
                            {cancelledServicesCounter}<span className="mx-1">{bookings.status.canceled}</span> &amp; 
                            <span className="mx-1">{bookingData?.appointment_branch_services?.length-(cancelledServicesCounter+doneServicesCounter)}</span>
                            {bookings.details.remining})
                        </div>)
                    }
                </div>
                {
                  bookingData?.appointment_branch_services?.map((service) => (
                    <div className="service-card mb-3" key={service.id}>
                        <div className="row p-3">
                            <div className="row justify-content-between">
                               <div className="fsize-18 fweight-600 mb-1 mb-md-1 col-md-3 col-sm-12">
                                   {service.service_title}
                                </div>
                                {bookingData?.status !== 'upcoming' && (
                                    <div className=" d-flex gap-2 justify-content-end align-items-start fsize-18 mb-1 mb-md-1 col-md-7 col-sm-12">
                                        {service.employee_did_not_show_up &&
                                            (<>
                                                <span className="bg-white rounded-4 text-center px-2 py-1 text-coral">
                                                    {bookings.details.reported}
                                                    {service.employee_did_not_show_up && <span>({bookings.details.employeeDidNotShowUp})</span>}
                                                    <FlagOutlined/>
                                                </span>
                                            </>)
                                        }
                                        {service.status === 'completed' &&
                                            (<>
                                                <span className="bg-white rounded-4 text-center px-3 py-1 text-green">
                                                    {bookings.status.completed}
                                                    <Check/>
                                                </span>
                                            </>)
                                        }
                                        {service.status === 'canceled' &&
                                            (<>
                                                <span className="bg-white rounded-4 text-center px-3 py-1 text-gray">
                                                    {bookings.status.canceled}
                                                    {service?.appointment_cancellation_reason && (
                                                        lang === 'en'
                                                            ? <span>({service.appointment_cancellation_reason.reason_en})</span>
                                                            : <span>({service.appointment_cancellation_reason.reason_ar})</span>
                                                    )}
                                                    {service?.refund_state === 'refunded' && (
                                                        <span> - {bookings.details.withRefund}</span>
                                                    )}
                                                    {service?.refund_state === 'not_refunded' && (
                                                        <span> - {bookings.details.withoutRefund}</span>
                                                    )}
                                                    <Clear/>
                                                </span>
                                            </>)
                                        }
                                        {bookingData?.status === 'ongoing' && (
                                            <>
                                                <Divider orientation="vertical" flexItem color="text-gray" />
                                                <Menu
                                                    list={showMenuList(service)}
                                                    onChangeValue={(listItem)=>{
                                                        handleOnClickItem(listItem, service)
                                                    }}
                                                    label={<MoreVertOutlined/>}
                                                    ButtonClassName="bg-white rounded-4 text-secondary"
                                                />
                                            </>)
                                        }
                                    </div>
                                )}
                            </div>
                            <div className="mb-1 mb-md-1 col-12 col-lg-3">
                                <div className="text-gray fsize-18 d-flex gap-2">
                                    <div><CreditCardOutlined/></div>
                                    <div>{bookings.details.fees}:</div>
                                </div>
                            </div>
                            <div className="mb-1 mb-md-1 col-12 col-lg-9">
                                <div className="text-gray fsize-18 d-flex gap-1 align-items-center">
                          { service.exact_fees ? (
                                        <div className="d-flex gap-1 align-items-center">
                                            {service.exact_fees}
                                            {service.currency?.icon_url && (
                                                <img
                                                    src={service.currency.icon_url}
                                                    alt={lang === 'en' ? service.currency.symbol_en : service.currency.symbol_ar}
                                                    style={{width: '16px', height: '16px'}}
                                                />
                                            )}
                                        </div>
                                    ) : (
                                        <div className="d-flex gap-1 align-items-center">
                                            {service.fees_from}
                                            {service.currency?.icon_url && (
                                                <img
                                                    src={service.currency.icon_url}
                                                    alt={lang === 'en' ? service.currency.symbol_en : service.currency.symbol_ar}
                                                    style={{width: '16px', height: '16px'}}
                                                />
                                            )}
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className="mb-1 mb-md-1 col-12 col-lg-3">
                                <div className="text-gray fsize-18 d-flex gap-2">
                                    <div><AccessTimeOutlined/></div>
                                    <div>{bookings.details.duration}:</div>
                                </div>
                            </div>
                            <div className="mb-1 mb-md-1 col-12 col-lg-9">
                                <div className="text-gray fsize-18 ">
                                    {service.starts_at && service.ends_at && (
                                        <div>
                                            {bookings.details.from}
                                            {timeConverter(service.starts_at, lang)}
                                            {bookings.details.to}
                                            {timeConverter(service.ends_at, lang)}
                                        </div>
                                    )}
                                    {!service.starts_at && !service.ends_at && (
                                        <div>
                                            {service.duration_mins} {bookings.addAnotherService.mins}
                                        </div>
                                    )}

                                </div>
                            </div>
                                    <div className="mb-1 mb-md-1 col-12 col-lg-3">
                                        <div className="text-gray fsize-18 d-flex gap-2">
                                            <div><ArticleOutlined/></div>
                                            <div>{bookings.details.description}:</div>
                                        </div>
                                    </div>
                                    <div className="mb-1 mb-md-1 col-12 col-lg-9">
                                        <div className="text-gray fsize-18">
                                            {service.description ? renderTextEllipsis(service.description) : bookings.details.noDescription}
                                        </div>
                                    </div>
                            <div className="mb-1 mb-md-1 col-12 col-lg-3">
                                <div className="text-gray fsize-18 d-flex gap-2 mb-1 mb-md-1">
                                   <div><Person2Outlined/></div>
                                   <div>{bookings.details.employeeName}:</div>
                                </div>
                            </div>
                            <div className="mb-1 mb-md-1 col-12 col-lg-9">
                                <div className="text-gray fsize-18">
                                {service?.employee?.is_deleted
                                        ? service.employee.username
                                        : (
                                            <Link
                                                to={ROUTE_PATHS.viewEmployee.replace(':id', service?.employee?.id)}
                                            >
                                                {service.employee.username}
                                            </Link>
                                          )
                                    }
                                </div>
                            </div>
                            <div className="mb-1 mb-md-1 col-12 col-lg-3">
                                <div className="text-gray fsize-18 d-flex gap-2">
                                    <div><CategoryOutlined/></div>
                                    <div>{bookings.details.serviceType}:</div>
                                </div>
                            </div>
                            <div className="mb-1 mb-md-1 col-12 col-lg-9">
                                <div className="text-gray fsize-18">
                                    {bookingData?.service_type === 'multi_session'
                                        ? bookings.details.multiSession
                                        : bookings.details.singleService
                                    }
                                </div>
                            </div>
                            {bookingData?.service_type === 'multi_session' && bookingData?.multi_session && (
                                <>
                                    <div className="mb-1 mb-md-1 col-12 col-lg-3">
                                        <div className="text-gray fsize-18 d-flex gap-2">
                                            <div><RepeatOutlined/></div>
                                            <div>{bookings.details.remainingSessions}:</div>
                                        </div>
                                    </div>
                                    <div className="mb-1 mb-md-1 col-12 col-lg-9">
                                        <div className="text-gray fsize-18">
                                            {bookingData.multi_session.remaining_sessions} {(bookingData.multi_session.remaining_sessions !== 1) ? bookings.details.sessions : bookings.details.session}
                                        </div>
                                    </div>
                                    <div className="mb-1 mb-md-1 col-12 col-lg-3">
                                        <div className="text-gray fsize-18 d-flex gap-2">
                                            <div><EventAvailableOutlined/></div>
                                            <div>{bookings.details.sessionsExpiry}:</div>
                                        </div>
                                    </div>
                                    <div className="mb-1 mb-md-1 col-12 col-lg-9">
                                        <div className="text-gray fsize-18">
                                            {bookingData.multi_session.expiry_date ? (
                                                lang === 'en' ?
                                                    dayjs(bookingData.multi_session.expiry_date).format("dddd, D MMMM YYYY") :
                                                    dayjs(bookingData.multi_session.expiry_date).locale('ar').format("dddd, D MMMM YYYY")
                                            ) : '-'}
                                        </div>
                                    </div>
                                    {/* Session number x out of x */}
                                    <div className="mb-1 mb-md-1 col-12 col-lg-3">
                                        <div className="text-gray fsize-18 d-flex gap-2">
                                            <div><NumbersOutlined/></div>
                                            <div>{bookings.history.sessionNumber}:</div>
                                        </div>
                                    </div>
                                    <div className="mb-1 mb-md-1 col-12 col-lg-9">
                                        <div className="text-gray fsize-18">
                                            {bookingData?.session_number} {bookings.history.outOf} {bookingData.multi_session.sessions_count}
                                        </div>
                                    </div>
                                    {/* Booking Date */}
                                    {bookingData?.booking_date && (
                                        <>
                                            <div className="mb-1 mb-md-1 col-12 col-lg-3">
                                                <div className="text-gray fsize-18 d-flex gap-2">
                                                    <div><CalendarMonthOutlined/></div>
                                                    <div>{bookings.history.bookingDate}:</div>
                                                </div>
                                            </div>
                                            <div className="mb-1 mb-md-1 col-12 col-lg-9">
                                                <div className="text-gray fsize-18">
                                                    {lang === 'en'
                                                        ? dayjs(bookingData.booking_date).format("dddd, D MMMM YYYY")
                                                        : dayjs(bookingData.booking_date).locale('ar').format("dddd, D MMMM YYYY")
                                                    }
                                                </div>
                                            </div>
                                        </>
                                    )}
                                </>
                            )}
                        </div>
                    </div>
                ))}
            </div>
            {bookingData?.status === 'completed' &&(
                <div className="bg-white row p-4 mx-1 data-container">
                    <div className="text-dark text-primary fsize-16 mb-2">
                        {bookings.details.totalAmountWithoutVAT}
                    </div>
                    <div className="text-gray fsize-18 mb-2 d-flex gap-1 align-items-center">
                        {bookingData?.total_exact_fees_without_vat}
                        {bookingData?.currency?.icon_url && (
                            <img
                                src={bookingData.currency.icon_url}
                                alt={lang === 'en' ? bookingData.currency.symbol_en : bookingData.currency.symbol_ar}
                                style={{width: '16px', height: '16px'}}
                            />
                        )}
                    </div>
                    <div className="text-dark text-primary fsize-16 mb-2">
                        {bookings.details.VAT}  ({bookingData?.vat}%)
                    </div>
                    <div className="text-gray fsize-18 mb-2">
                        {bookingData?.vat_amount}
                    </div>
                    <div className="text-dark text-primary fsize-16 mb-2">
                        {bookings.details.totalAmountWithVAT}
                    </div>
                    <div className="text-gray fsize-18 mb-2 d-flex gap-1 align-items-center">
                        {bookingData?.total_exact_fees}
                        {bookingData?.currency?.icon_url && (
                            <img
                                src={bookingData.currency.icon_url}
                                alt={lang === 'en' ? bookingData.currency.symbol_en : bookingData.currency.symbol_ar}
                                style={{width: '16px', height: '16px'}}
                            />
                        )}
                    </div>
                </div>
            )}
            <Modal
                open={showCancelUpcomingPopup}
                handleClose={handleCloseCancelUpcoming}
                title={<span className="fsize-26 fweight-400">{bookings.details.cancelBooking}</span>}
                contentClass="mb-3 pb-2 text-primary"
                content={<span className="fsize-20 fweight-400">{isUpcomingFirstSessionMultiSession ? bookings.details.multiSessionCancelWholeAppointmentConfirm : isUpcomingSubsequentMultiSession ? bookings.details.cancelUpcomingSessionPopupContent : bookings.details.cancelUpcomingPopupContent}</span>}
                confirmBtnTxt={shared.confirm}
                cancelBtnTxt={shared.cancel}
                isContentText={false}
                handleConfirm={handleSubmitCancelUpcoming}
                handleCancel={handleCloseCancelUpcoming}
                maxWidth="sm"
                actionsClass=" px-4"
                confirmBtnClass="btn-secondary fsize-14 text-white py-2 px-5"
                cancelBtnClass="fsize-14 py-2 text-secondary px-5 "
            />
            <Modal
                open={showRefuseToCancelPopup}
                handleClose={handleCloseRefuseToCancel}
                title={<span className="fsize-26 fweight-400">{bookings.details.cancelBooking}</span>}
                contentClass="mb-3 pb-2 text-primary"
                content={<span className="fsize-18 fweight-400">{bookings.details.refuseToCancelPopupContent}</span>}
                confirmBtnTxt={shared.cancel}
                isContentText={false}
                handleConfirm={handleCloseRefuseToCancel}
                maxWidth="sm"
                actionsClass=" px-4"
                confirmBtnClass="btn-secondary fsize-14 text-white py-2 px-5"
            />
            <BookingCancelationReasonForm
                open={showBookingCancelationReasonPopup}
                setOpen={setShowBookingCancelationReasonPopup}
            />
            <BookingServiceCancelationReasonForm
                open={showServiceCancelationReasonPopup}
                setOpen={setShowServiceCancelationReasonPopup}
                cancelService={cancelService}
            />
            <BookingFirstSessionCancelForm
                open={showFirstSessionCancelForm}
                setOpen={setShowFirstSessionCancelForm}
                buttonType={firstSessionButtonType}
                cancelService={cancelService}
            />
            <BookingSubsequentSessionCancelForm
                open={showSubsequentSessionCancelForm}
                setOpen={setShowSubsequentSessionCancelForm}
                buttonType={subsequentSessionButtonType}
                cancelService={subsequentCancelService}
            />
            <Modal
                open={openMap}
                handleClose={() => setOpenMap(false)}
                title={<h2>{branches.viewBranch.labels.supportedRegions}</h2>}
                contentClass="mb-5 pb-2 text-primary"
                content={<SelectLocation viewMapInModelOnly={true} showCoords={viewBranchPointerOnMap()} />}
                confirmBtnTxt={shared.confirm}
                isContentText={false}
                handleConfirm={() => setOpenMap(false)}
                maxWidth="lg"
                actionsClass="container px-4"
                confirmBtnClass="btn-secondary fsize-14 text-white py-2 "
                cancelBtnClass="fsize-14 py-2"
                cancelBtnTxt={shared.cancel}
                handleCancel={() => setOpenMap(false)}
                modalClass="map-modal"
                hasActions={false}
                disableActionBtn={false}
            />
        </div>    
    )
};

export default ViewBooking;